import React from 'react';
import { Badge, badgeTypes } from '../Badge';

export const DistributionListsStatus = {
  active: 1,
  disabled: 2,
  deleted: 3,
};

export const DistributionListsStatusNames = {
  [DistributionListsStatus.active]: 'Active',
  [DistributionListsStatus.disabled]: 'Disabled',
  [DistributionListsStatus.deleted]: 'Deleted',
};


/**
 * Status badge component for distribution lists
 */
export const DistributionListStatusBadge = ({ status }) => {
  const getBadgeType = (status) => {
    switch (status) {
      case DistributionListsStatus.active:
        return badgeTypes.success;
      case DistributionListsStatus.disabled:
        return badgeTypes.warn;
      case DistributionListsStatus.deleted:
      default:
        return badgeTypes.default;
    }
  };

  return <Badge type={getBadgeType(status)} text={DistributionListsStatusNames[status]} />;
};

export default DistributionListStatusBadge;